export default (https) => ({
  async getList() {
    const response = await https.get('/part-types');
    return response.data;
  },
  async add(payload) {
    const response = await https.post('/part-types', payload);
    return response.data;
  },
  async update(id, payload) {
    const response = await https.put(`/part-types/${id}`, payload);
    return response.data;
  },
  async deleteById(id) {
    const response = await https.delete(`/part-types/${id}`);
    return response.data;
  },
});
